import { getRegistrars } from './getRegistrars';

export const fetchRegistrars = async (companyId) => {
    try {
        if (!companyId) {
            throw new Error('No company selected');
        }
        const response = await getRegistrars(companyId);
        return response.data;
    } catch (error) {
        console.error('Error fetching registrars:', error);
        throw error;
    }
};
